import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import DivButton from 'GeneralUI/DivButton/DivButton.jsx'

const RefreshButton = ({visible, onClick = () => null}) => {
  if (visible === true) {
    return (
      <DivButton
        className={'btn btn-default control-button'}
        data-toggle={'tooltip'}
        data-title={'Reload data'}
        aria-label={'reload button'}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={['fas', 'redo']} size="sm" fixedWidth />
      </DivButton>
    )
  } else {
    return null
  }
}

export default RefreshButton